import { FC } from 'react'
import { Button } from 'antd'
import { EditOutlined } from '@ant-design/icons'
import FormModal from '../../../../components/form-modal/form-modal'
import PrintJob from '../../../../types/api/print-job'
import { hasSavedMaterialConsumptions } from '../../helpers/consumption-helpers'
import ConsumptionForm from './consumption-form'

interface ConsumptionFormModalProps {
    printJob: PrintJob
    onSuccess: () => void
}

const ConsumptionFormModal: FC<ConsumptionFormModalProps> = ({ printJob, onSuccess }) => {
    if (hasSavedMaterialConsumptions(printJob)) return null

    const shipmentId = printJob.shipment?.id

    return (
        <FormModal
            width={800}
            title={`Расход${shipmentId ? ` — отгрузка ${shipmentId}` : ''}`}
            renderOpener={onOpen => (
                <Button size="small" icon={<EditOutlined />} title="Заполнить расход" onClick={onOpen} />
            )}
            renderContent={onClose => (
                <ConsumptionForm printJob={printJob} onSuccess={onSuccess} onClose={onClose} />
            )}
        />
    )
}

export default ConsumptionFormModal
